import { colorScheme } from "./color-scheme";

export const darkTheme = {
    name: "dark",
    colorScheme: colorScheme,
    component: {
        dataZoom: {
            selectedBackground: {
                style: {
                    fillOpacity: .4,
                    outerBorder: {
                        strokeOpacity: .4
                    }
                }
            }
        }
    }
};
//# sourceMappingURL=index.js.map
